import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { apiInstance } from '../axios/axiosInstance';
import translationJP from './ja.json';
import translationEN from './en.json';
import { initReactI18next } from 'react-i18next';

const fallbackTranslations: Record<string, any> = {
    en: {
        translation: translationEN,
    },
    ja: {
        translation: translationJP,
    },
};

const loadResources = async (locale: string) => {
    try {
        const response = await apiInstance.get('/language/get', {
            params: { lang: locale },
        });
        i18n.addResourceBundle(locale, 'translation', response.data, false, true);
        return response.data;
    } catch (error) {
        if (fallbackTranslations[locale]) {
            i18n.addResourceBundle(
                locale,
                'translation',
                fallbackTranslations[locale].translation,
                true,
                true,
            );
        } else {
            i18n.addResourceBundle(
                locale,
                'translation',
                fallbackTranslations['ja'].translation,
                false,
                true,
            );
        }
        return {};
    }
};

const backendOptions: HttpBackendOptions = {
    loadPath: '/language/get?lang={{lng}}',
    request: async (_options, url, _payload, callback) => {
        const lng = url.substring(url.indexOf('lang=') + 5);
        const response = await loadResources(lng);
        callback(null, response);
    },
};

i18n
    // .use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init(
        {
            // resources: fallbackTranslations,
            backend: backendOptions,
            lng: 'ja',
            fallbackLng: 'ja',
            debug: false,
            ns: ['translation'],
            defaultNS: 'translation',
            keySeparator: false,
            interpolation: { escapeValue: false },
            react: {
                useSuspense: true,
            },
        },
        () => {
            console.log('- i18n initialized');
        },
    );

export default i18n;
